export const forestName = (forest) => {
  if (forest.name && forest.name.length > 0) {
    return `${forest.name}, ${forest.municipality}`;
  } else {
    return forest.municipality;
  }
};
